import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {MatDialogActions, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { skip } from 'rxjs/operators';

import { ThemeService } from '~/core/services/theme.service';
import { User } from '~/core/models/user';
import { UtilsService } from '~/core/helpers/utils';
import { KycValidationService } from '~/core/helpers/kyc-validation.service';
import { KycTypeEnum } from '~/core/enum/kyc-type.enum';
import { ActionType } from '~/pages/back-office/config/client-config/add-edit-kyc-action/add-edit-kyc-action.component';
import {DatePipe, NgClass} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {FlexModule} from "@ngbracket/ngx-layout";
import {StButtonComponent} from "~/dash/core/st-button/st-button.component";

@Component({
    selector: 'app-user-information-confirmation-dialog',
    templateUrl: './user-information-confirmation-dialog.component.html',
    styleUrls: ['./user-information-confirmation-dialog.component.scss'],
    imports: [
        NgClass,
        TranslateModule,
        MatDialogContent,
        FlexModule,
        DatePipe,
        MatDialogActions,
        StButtonComponent
    ]
})
export class UserInformationConfirmationDialogComponent implements OnInit {
  @Input() isDark: boolean = !ThemeService.isLightTheme;
  @Input() user: User;
  @Output() closeFunc = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<UserInformationConfirmationDialogComponent>,
    protected kycValidationService: KycValidationService,
  ) {}

  ngOnInit() {
    this.kycValidationService.$kycSuccess.pipe(skip(1)).subscribe(() => {
      this.dialogRef.close();
      this.closeFunc.emit(false);
    });
  }

  close() {
    const uuidCode = UtilsService.generateUUID();
    this.kycValidationService.hasRetry = false;
    this.kycValidationService.showKycNotificationModal(uuidCode, KycTypeEnum.FULL, ActionType.REGISTRATION, 'ACTION');
  }

  parsePhone = (phone: string) => parsePhoneNumberFromString('+' + phone)?.formatInternational() || phone;
  cpfFormatter = (cpf: string) => UtilsService.cpfFormatter(cpf);
}
